module.exports = __webpack_public_path__ + "static/img/coin_2.b9994df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/guide/coin_2.png
// module id = aA32
// module chunks = 4